import { GroupOption } from '@/presentation/components/generalizations/enrolments-table-group-selector/selectors/group-option';
import { GroupOptionsEnums } from '@/models/group-options-enums';

export class ReviewDateGroupOption extends GroupOption {
	public get displayText(): string {
		return 'Review date';
	}
	public equals(option: GroupOption): boolean {
		return option instanceof ReviewDateGroupOption;
	}
	public getHashKey(): GroupOptionsEnums {
		return GroupOptionsEnums.REVIEW_DATE_GROUP_OPTION;
	}
}
